import { POST } from '@/admin-shared-modules/utils/ajax'
import LoadingService from '@/admin-shared-modules/utils/loading.service'
import { MessageService } from '@/admin-shared-modules/utils/message.service'
import { AbstractEditService } from '@/core/services/edit.service'
import { AbstractListService } from '@/core/services/list.service'
import { AbstractSearchService } from '@/core/services/search.service'
import { reactive } from 'vue'

class Search extends AbstractSearchService<Store> {
  onSubmit(): void {
    this.context.list.fetch({ reset: true })
  }
}

class List extends AbstractListService<Store> {
  getFetchURL(): string {
    return 'homepage_template/list'
  }
  getSearchParams(): any {
    return this.context.search.getSearchParams()
  }
}

class Edit extends AbstractEditService<Store> {
  getFetchURL(): string {
    return `homepage_template/${this.params.id}`
  }
  getDefaultFormData() {
    return {}
  }
  getRemoveURL(): string {
    return `homepage_template/${this.params.id}`
  }
  getSubmitURL(): string {
    return this.isEdit
      ? `homepage_template/${this.data.id}`
      : 'homepage_template'
  }
  requestListReload(option?): void {
    this.context.list.fetch(option)
  }

  async onCopy(row: any): Promise<void> {
    LoadingService.create('正在复制模板...')
    this.context.list.loading = true

    const { title, devices, template } = row
    await POST('homepage_template', {
      data: {
        title: title + ' - 复制',
        devices,
        template
      }
    })
    this.context.list.fetch({ reset: true })

    LoadingService.close()
    MessageService.open({
      type: 'success',
      message: '复制成功'
    })
  }
}

class Store {
  list: List
  edit: Edit
  search: Search
  constructor() {
    this.list = new List(this)
    this.edit = new Edit(this)
    this.search = new Search(this)
  }
}

export const store = reactive(new Store())
